import React from "react";
import { PageLoading } from "../../components";
import { usePrimaryOrganizationId, useSelf } from "../../hooks";
import { InviteUsersAquilo, WelcomeOverlay } from "../../components/get-compliant/WelcomeOverlay";
import { useHistory } from "react-router";
import { useSelfOrganizationUser } from "../../hooks/useOrganization";
import { Routes } from "../../root/routes";
import { useGetCompliantContext } from "../../root/GetCompliantContext";
import { StepComparison } from "../../surveys/steps/GetCompliantSteps";
import { getStepLogic } from "../../surveys/steps/GetCompliantStepLogic";

export const GetCompliantDashboardPage: React.FC = () => {
  const organizationId = usePrimaryOrganizationId()!!;
  const [self] = useSelf();
  const selfOrgUser = useSelfOrganizationUser();
  const history = useHistory();

  const { progress } = useGetCompliantContext();

  if (!self || !selfOrgUser) {
    return <PageLoading />;
  }

  return (
    <WelcomeOverlay
      organizationId={organizationId}
      skipInvitations={selfOrgUser?.role !== "ADMIN" || self?.viewedWelcomeScreen}
      onClose={() => {
        if (selfOrgUser.role === "HR") {
          history.push(Routes.getCompliant.employeeMap.introduction);
        } else {
          if (StepComparison.isAfter(progress, "BusinessSurvey.BusinessSurvey")) {
            let stepLogic = getStepLogic(progress);
            history.push(stepLogic.route);
          } else {
            history.push(Routes.getCompliant.privacyCenter.emailSetup);
          }
        }
      }}
      alreadyViewedWelcomeScreen={self?.viewedWelcomeScreen}
    />
  );
};

export function GetCompliantInviteUsersPage() {
  const history = useHistory();
  const organizationId = usePrimaryOrganizationId()!!;

  if (!organizationId) {
    return <PageLoading />;
  }

  return (
    <InviteUsersAquilo
      organizationId={organizationId}
      onDone={() => {
        history.push(Routes.getCompliant.privacyCenter.emailSetup);
      }}
    />
  );
}
